import { render } from "./AINavigationMobile.vue?vue&type=template&id=05149cdf&scoped=true"
import script from "./AINavigationMobile.vue?vue&type=script&lang=js"
export * from "./AINavigationMobile.vue?vue&type=script&lang=js"

import "./AINavigationMobile.vue?vue&type=style&index=0&id=05149cdf&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05149cdf"]])

export default __exports__